export default {
  styleOverrides: {
    root: {
      marginRight: 8,
      marginBottom: 8,
    },
  },
}
